<template>
	<div class="container-fluid">
		<loading
            :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="true"
            color="#007bff"
      		background-color="#ffffff"
        >
        </loading>
        <div v-if="errors != null">
			<save-error
				@close="errors = null"
				:errors="errors"
				:text="'Hiányzó adatok a számlázáshoz'"
			/>
		</div>
		<div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Rendelés keresés
    		</div>
		</div>
		<div class="row d-flex justify-content-center align-items-center text-center">
			<div class="col-6 col-lg-2">
	          	<div class="m-2">
	          		<span class="h6">Rendelés státusza</span>
	          		<select v-model="search.aktiv" class="form-control">
				  		<option :value="0">Lezárt</option>
				  		<option :value="1">Nyitott</option>
				  		<option :value="2">Mindkettő</option>
					</select>
	          	</div>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<div class="m-2">
	          		<span class="h6">Számlázva</span>
	          		<select v-model="search.szamlazva" class="form-control">
			  			<option :value="0">Nincs számlázva</option>
			  			<option :value="1">Számlázva</option>
			  			<option :value="2">Mindkettő</option>
					</select>
	          	</div>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Régió</span>
	            	<div class="input-group">
	              		<input type="number" class="form-control text-center" v-model="search.regio_kezd"></input>
	              		<input type="number" class="form-control text-center" v-model="search.regio_veg"></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-12 col-lg-6">
	        	<button
	        		class="btn btn-outline-primary m-1"
	        		@click.prevent="regio_set(v.start,v.end)"
	        		v-for="(v,k) in regioButtons"
	        		:key="k"
	        	>
	        		{{v.start}}-{{v.end}}
	        	</button>
	        </div>
		</div>

		<div class="row d-flex justify-content-center text-center">
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél név</span>
	            	<span class="h6 text-danger clear" v-show="search.nev != ''" @click.prevent="clear('nev')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.nev"></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél sorszám</span>
	            	<span class="h6 text-danger clear" v-show="search.uszam != ''" @click.prevent="clear('uszam')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.uszam"></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél irányítószám</span>
	            	<span class="h6 text-danger clear" v-show="search.iszam != ''" @click.prevent="clear('iszam')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.iszam"></input>
	            	</div>
	          	</div>
	        </div>
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél város</span>
	            	<span class="h6 text-danger clear" v-show="search.varos != ''" @click.prevent="clear('varos')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.varos"></input>
	            	</div>
	          	</div>
	        </div>
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél cím</span>
	            	<span class="h6 text-danger clear" v-show="search.cim != ''" @click.prevent="clear('cim')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.cim"></input>
	            	</div>
	          	</div>
	        </div>
	    </div>
	    <div class="row d-flex justify-content-center text-center">
	        <div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Nullás tételek kihagyása</span>
	            	<select v-model="search.nullas" class="form-control">
				  		<option value="0">NEM</option>
				  		<option value="1">IGEN</option>
					</select>
	          	</div>
	        </div>
	        <div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Kiegyenlítve</span>
	            	<select v-model="search.fizetve" class="form-control">
				  		<option value="99">Minden</option>
				  		<option value="0">NEM</option>
				  		<option value="1">IGEN</option>
					</select>
	          	</div>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Rögzítette</span>
	          	<select v-model="search.rogzit" class="form-control">
				  <option
				  	v-for="(item,index) in users"
				  	:value="item.user"
				  	:key="`rogzit-${index}`"
				  	v-show="item.aktiv ==1"
				  >
				  	{{item.user}}
				  </option>
				</select>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Lezárta</span>
	          	<select v-model="search.lezarta2" class="form-control">
				  <option
				  	v-for="(item,index) in zaruser"
				  	:value="item.lezarta2"
				  	:key="`lezar-${index}`"
				  	v-show="item.aktiv ==1"
				  >
				  	{{item.nev}}
				  </option>
				</select>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Megjegyzés</span>
	          	<input type="text" v-model="search.megj" class="form-control">
	        </div>
	    </div>
	    <div class="row d-flex justify-content-center text-center">
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Szolgáltató</span>
	          	<select v-model="search.szolg" class="form-control">
				  <option v-for="(item,index) in szolg" :value="item.id" :key="`szolg-${index}`">
				  	{{item.nev}}
				  </option>
				</select>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Ügyfél kategória</span>
	          	<select v-model="search.kategoria_id" class="form-control">
				  <option v-for="(item,index) in kat" :value="item.kszam">
				  	{{item.nev}}
				  </option>
				</select>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Ügyfél típus</span>
	          	<select v-model="search.tipus_id" class="form-control">
				  <option v-for="(item,index) in tip" :value="item.kszam">
				  	{{item.nev}}
				  </option>
				</select>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Számla kiállító</span>
	          	<v-select
					:options="szla_szolg"
					v-model="search.szla_szolg"
					:reduce="x => x.code"
					multiple
				>
				</v-select>
	        </div>
	        <div class="col-6 col-lg-2">
	          	<span class="h6">Számla típus</span>
	          	<select v-model="search.szla_tipus" class="form-control">
				  <option v-for="(item,index) in szla_tipusok" :value="item.id" :key="`szt-${index}`">
				  	{{item.nev}}
				  </option>
				</select>
	        </div>

	    </div>

	    <div class="row d-flex justify-content-center text-center">
	        <div class="col-6 col-lg-2">
	        	<div class="m-2">
	        		<span class="h6">Kiszállító</span>
	        		<select v-model="search.kiszallito" class="form-control">
						<option value="-1">Minden</option>
						<option
							v-for="(v,k) in kiszallitok"
							:key="k"
							:value="v.azon"
						>
							{{ v.nev }}
						</option>
					</select>
				</div>
        	</div>

        	<div class="col-6 col-lg-2">
        		<div class="m-2">
	            	<span class="h6">Rendelés sorszám</span>
	            	<span class="h6 text-danger clear" v-show="search.rendelesszam != ''" @click.prevent="clear('rendelesszam')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.rendelesszam"></input>
	            	</div>
	          	</div>
        	</div>

	    </div>
	    <div class="row d-flex justify-content-center align-items-center">
	        <div class="col-10">
	        	<hr>
	        </div>
	    </div>

	    <div class="row d-flex justify-content-center align-items-center text-center">
	    	<div class="col-6 col-lg-2">
	    		<div class="m-1">
        			<span>{{search.ki_datum_tol | day }}</span>
  					<date-picker class="text-center" v-model="search.ki_datum_tol" :config="date_options" placeholder="-tól"/>
  				</div>
  			</div>
  			<div class="col-6 col-lg-2">
  				<div class="m-1">
  					<span>{{search.ki_datum_ig | day }}</span>
        			<date-picker class="text-center" v-model="search.ki_datum_ig" :config="date_options" placeholder="-ig (kötelező)"/>
        		</div>
        	</div>
        	<div class="col-12 col-lg-2">
        		<div class="h5">Kért szállítási dátum</div>
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_past"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('ki_datum_tol','-',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_now"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('ki_datum_ig','+',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
			<div class="col-12">
        		<button
        			class="btn btn-outline-primary m-1"
        			v-for="(v,k) in dateButtons"
        			:key="k"
        			@click.prevent="setDate('ki_datum_',v)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-10 mb-2">
	        	<hr>
	        </div>
	    </div>

	    <div class="row d-flex justify-content-center align-items-center text-center mt-2">
        	<div class="col-6 col-lg-2">
        		<div class="m-1">
        			<span>{{search.r_datum_tol | day }}</span>
  					<date-picker class="text-center" v-model="search.r_datum_tol" :config="date_options" placeholder="-tól"/>
        		</div>
  			</div>
  			<div class="col-6 col-lg-2">
  				<div class="m-1">
  					<span>{{search.r_datum_ig | day }}</span>
        			<date-picker class="text-center" v-model="search.r_datum_ig" :config="date_options" placeholder="-ig"/>
  				</div>
        	</div>
        	<div class="col-12 col-lg-2">
        		<div class="h5">Rögzítés dátuma</div>	
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_past"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('r_datum_tol','-',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_now"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('r_datum_ig','+',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-12">
        		<button
        			class="btn btn-outline-primary m-1"
        			v-for="(v,k) in dateButtons"
        			:key="k"
        			@click.prevent="setDate('r_datum_',v)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-10 mb-2">
	        	<hr>
	        </div>
	    </div>

	    <div class="row d-flex justify-content-center align-items-center text-center">
	    	<div class="col-6 col-lg-2">
	    		<div class="m-1">
        			<span>{{search.t_datum_tol | day }}</span>
  					<date-picker class="text-center" v-model="search.t_datum_tol" :config="date_options" placeholder="-tól"/>
  				</div>
  			</div>
  			<div class="col-6 col-lg-2">
  				<div class="m-1">
  					<span>{{search.t_datum_ig | day }}</span>
        			<date-picker class="text-center" v-model="search.t_datum_ig" :config="date_options" placeholder="-ig"/>
  				</div>
        	</div>
        	<div class="col-12 col-lg-2">
        		<div class="h5">Tényleges lezárás dátuma</div>
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_past"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('t_datum_tol','-',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_now"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('t_datum_ig','+',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-12">
        		<button
        			class="btn btn-outline-primary m-1"
        			v-for="(v,k) in dateButtons"
        			:key="k"
        			@click.prevent="setDate('t_datum_',v)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
			<div class="col-10 mb-2">
				<hr>
			</div>
		</div>

		<div class="row d-flex justify-content-center text-center mt-2">
			<div class="col-12 col-md-6 col-lg-3">
				<button
					class="btn btn-lg btn-outline-danger m-1"
					@click.prevent="defaultsearch"
				>
					Keresési feltételek alapértelmezése
				</button>
			</div>
			<div class="col-12 col-md-6 col-lg-6">
				<button
					class="btn btn-lg btn-outline-primary m-1"
					@click.prevent="getsearch"
				>
					Keresés
				</button>
				<button
					class="btn btn-lg btn-outline-primary m-1"
					@click.prevent="getsearchsum"
				>
					Csak összegzés
				</button>
				<button
					class="btn btn-lg btn-warning m-1"
					disabled
				>
					{{list.length}} rendelés
				</button>
				<button
					class="btn btn-lg btn-warning m-1"
					disabled
				>
					{{listCount}} rendelésszám
				</button>
			</div>

			<div class="col-12 col-md-6 col-lg-3">
				<div class="input-group m-1">
				  	<select class="form-select" v-model="downloadValue">
				    	<option :value="0">Mindet</option>
				    	<option :value="1">Csak a kijelöltek</option>
				  	</select>

				  	<button class="btn btn-lg btn-outline-success" type="button" @click.prevent="print">
				  		Letöltés
				  	</button>
				</div>
			  	
			  	<button
			  		class="btn btn-lg btn-outline-success m-1"
			  		type="button"
			  		@click.prevent="print2"
			  	>
			  		Jegyzőkönyv
			  	</button>
			  
			  	<!--
			  	<delivery-protocol
			  		:list=""
			  	>
			  	</delivery-protocol>
			  -->
			</div>
		</div>

		<div class="row d-flex justify-content-center">
			<div class="col-10">
				<hr>
			</div>
		</div>
	    
	    <div class="row d-flex justify-content-center">
	    	<div class="table-responsive">
	      		<table class="table">
					<thead class="thead-light">
			            <th>Rögzítette</th>
			            <th>Lezárta</th>
			            <th>Számla kiállító</th>
			            <th>Kért dátum</th>
			            <th>Telefon</th>
			            <th>Név</th>
			            <th>Irányítószám</th>
			            <th>Város</th>
			            <th>Cím</th>
			            <th>Tétel</th>
			            <th>Db</th>
			            <th>Egységár</th>
			            <th>Fiz.mód</th>
			            <th>Számla</th>
			            <th>Megj</th>
			            <th>Érték</th>
			        </thead>
				    <tbody>
				        <tr>
				            <td><input type="checkbox" v-model="show.rogzitette"/></td>
				            <td><input type="checkbox" v-model="show.lezarta"/></td>
				            <td><input type="checkbox" v-model="show.szla_szolg"/></td>
				            <td><input type="checkbox" v-model="show.kerdatum"/></td>
				            <td><input type="checkbox" v-model="show.telefon"/></td>
				            <td><input type="checkbox" v-model="show.nev"/></td>
				            <td><input type="checkbox" v-model="show.iszam"/></td>
				            <td><input type="checkbox" v-model="show.varos"/></td>
				            <td><input type="checkbox" v-model="show.cim"/></td>
				            <td><input type="checkbox" v-model="show.tetel"/></td>
				            <td><input type="checkbox" v-model="show.db"/></td>
				            <td><input type="checkbox" v-model="show.ar"/></td>
				            <td><input type="checkbox" v-model="show.fizmod"/></td>
				            <td><input type="checkbox" v-model="show.invnumber"/></td>
				            <td><input type="checkbox" v-model="show.megj"/></td>
				            <td><input type="checkbox" v-model="show.ertek"/></td>
				        </tr>
				    </tbody>
				</table>
	      	</div>

	    	<div class="table-wrapper" v-show="list.length > 0">
	      		<table class="table table-hover">
				    <thead class="thead-light">
				        <tr>
				        	<th class="table-header">
				        		<input type="checkbox" class="checkbox-lg" v-model="check" @change="check_list">
				        	</th>
				            <th v-show="show.rogzitette">Rögzítette</th>
				            <th v-show="show.lezarta">Lezárta</th>
				            <th v-show="show.szla_szolg">Számla kiállító</th>
				            <th v-show="show.kerdatum">
				            	<a href="" class="hover" @click.prevent="order='kidatum'">Kért dátum</a>
                				<i
                					v-show="order=='kidatum'"
                					class="fas fa-lg fa-sort float-right text-danger"
                					@click.prevent="order_dir = !order_dir"
                				></i>
                			</th>
				            <th v-show="show.telefon">Telefon</th>
				            <th v-show="show.nev">Név</th>
				            <th>
				            	<a href="" class="hover" @click.prevent="order='regio'">Régió</a>
                				<i
                					v-show="order=='regio'"
                					class="fas fa-lg fa-sort float-right text-danger"
                					@click.prevent="order_dir = !order_dir"
                				></i>
				            </th>
				            <th v-show="show.iszam">Irányítószám</th>
				            <th v-show="show.varos">Város</th>
				            <th v-show="show.cim">Cím</th>
				            <th v-show="show.tetel">Tétel</th>
				            <th v-show="show.db">Db</th>
				            <th v-show="show.ar">Egységár</th>
				            <th v-show="show.fizmod">Fiz.mód</th>
				            <th v-show="show.invnumber">Számla</th>
				            <th v-show="show.megj">Megj</th>
				            <th v-show="show.ertek">Érték</th>
				            <th>Számlázva</th>
				            <th>Kiegyenlítve</th>
				            <th>Kiszállítva</th>
				            <th>Módosít</th>
				        </tr>
				    </thead>
				    <tbody>
				        <tr
				        	v-for="(obj,index) in list"
				        	:key="obj.id"
				        	:class="[
				        		obj.aktiv==1 && obj.szamlazva==1 ? 'text-danger' : '',
				        		obj.aktiv==0 && obj.szamlazva==1 ? 'text-success' : '',
				        		obj.aktiv==0 && obj.szamlazva==0 ? 'text-primary' : '',
				        	]"
				        >
				        	<td>
				              	<input
				              		class="checkbox-lg"
				              		type="checkbox"
				              		v-model="obj.check"
				              		:id="`c-${index}`"
				              		:key="`check-${index}`"
				              	>
				            </td>
				            <td v-show="show.rogzitette">{{obj.user}}</td>
				            <td v-show="show.lezarta">{{obj.lezarta}}</td>
				            <td v-show="show.szla_szolg">{{obj.szla_nev}}</td>
				            <td v-show="show.kerdatum">{{obj.kidatum | toDate}}</td>
				            <td v-show="show.telefon">{{obj.telv}} {{obj.telm}} </td>
				            <td v-show="show.nev">{{obj.nev}}</td>
				            <td>{{obj.regio}}</td>
				            <td v-show="show.iszam">{{obj.iszam}}</td>
				            <td v-show="show.varos">{{obj.varos}}</td>
				            <td v-show="show.cim">{{obj.cim}}</td>
				            <td v-show="show.tetel">{{obj.termek_nev}}</td>
				            <td v-show="show.db">{{obj.db}} db</td>
				            <td v-show="show.ar">{{obj.ar | huf}} Ft</td>
				            <td v-show="show.fizmod">
				            	{{ szla_tipusok[obj.szla_tipus].nev }}
				            </td>
				            <td v-show="show.invnumber">
				            	{{ obj.invoice_number }}
				            </td>
				            <td v-show="show.megj">{{obj.rendmegj}}</td>
				            <td v-show="show.ertek">{{obj.db*obj.ar | huf}}</td>
				            <td>
				            	<button
				            		class="btn btn-outline-success"
				            		@click.prevent="change_szamlazva(index)"
				            		v-show="obj.szamlazva === 1"
				            	>
				            		Számlázva
				            	</button>
				            	<button
				            		class="btn btn-outline-primary"
				            		@click.prevent="change_szamlazva(index)"
				            		v-show="obj.szamlazva === 0"
				            	>
				            		Nincs számlázva
				            	</button>
				            </td>
				            <td>
				            	<span v-if="obj.fizetve == 0">NEM</span>
				            	<span v-else>IGEN</span>
				            </td>
				            <td>
				            	<button
				            		class="btn btn-outline-success"
				            		@click.prevent="change_lezarva(index)"
				            		v-show="obj.aktiv === '0'"
				            	>
				            		Lezárva
				            	</button>
				            	<button
				            		class="btn btn-outline-primary"
				            		@click.prevent="change_lezarva(index)"
				            		v-show="obj.aktiv === '1'"
				            	>
				            		Nincs lezárva
				            	</button>
				            </td>
				            <td>
				            	<router-link
				            		class="btn btn-outline-primary"
					                :to="`/order/${obj.id}`" target="_blank"
					            >
					            	Módosít
					            </router-link>
				            </td>
				        </tr>
				    </tbody>
				</table>
	      	</div>
	    </div>
	    <div class="pb-1 pt-1">
	    	<div class="alert alert-">
	    		<div class="h6 text-center">
	    			<div class="row d-flex justify-content-center align-items-center">
	    				<div class="col-12 col-md-3">
	    					Rendelés NINCS kiszámlázva, NINCS kiszállítva
		    			</div>
		    			<div class="col-12 col-md-3 text-danger">
		    				Rendelés kiszámlázva, de NINCS kiszállítva, színe: piros.			
		    			</div>
		    			<div class="col-12 col-md-3 text-success">
		    				Rendelés kiszámlázva, kiszállítva, színe: zöld.
		    			</div>
		    			<div class="col-12 col-md-3 text-primary">
		    				Rendelés NINCS kiszámlázva, de kiszállítva, színe: kék.
		    			</div>
	    			</div>
	    		</div>
	    	</div>
	    </div>
	    <div class="pb-3 pt-3" v-show="checked_items.length === 0">
	        <div class="alert alert-warning">
	            <div class="h5 text-center">
	                Nincs kijelölve rendelés csoportos műveletre
	            </div>
	        </div>
	    </div>

	    <div class="pb-3 pt-3" v-show="checked_items.length > 0">
	        <div class="alert alert-primary">
	            <div class="h5 text-center">
	                Csoportos műveletek a kijelölt rendeléseken - {{checked_items.length}} tétel
	                {{ checked_items_sum |huf }} Ft összegben
	            </div>
	        </div>
	        <div class="m-2">
	            <div class="row d-flex justify-content-center align-items-center text-center">
	                <div class="col-6 col-lg-4">
	                    <div class="m-2">
	                        <span class="h5">Kiszállítási dátum módosítása</span>
	                        <div class="row">
	                        	<div class="col-9">
	                        		<span>{{ cs_kidatum | day}}</span>
	                        		<date-picker class="text-center" v-model="cs_kidatum" :config="date_options" placeholder="Dátum"/>		
	                        	</div>	
	                        	<div class="col-3">
	                        		<button
		                                class="btn btn-primary"
		                                :disabled="cs_kidatum === null"
		                                @click.prevent="cs_change('kidatum',cs_kidatum)"
		                            >
		                                Módosít
		                            </button>
	                        	</div>	
	                        </div>
	                    </div>
	                </div>
	                <div class="col-6 col-lg-4">
	                    <div class="m-2">
	                        <span class="h5">Lezárási dátum módosítása</span>
	                        <div class="row">
	                        	<div class="col-9">
	                        		<span>{{ cs_zardatum | day}}</span>
	                        		<date-picker class="text-center" v-model="cs_zardatum" :config="date_options" placeholder="Dátum"/>		
	                        	</div>	
	                        	<div class="col-3">
	                        		<button
		                                class="btn btn-primary"
		                                :disabled="cs_zardatum === null"
		                                @click.prevent="cs_change('zardatum',cs_zardatum)"
		                            >
		                                Módosít
		                            </button>
	                        	</div>
	                        </div>
	                    </div>
	                </div>
	                <div class="col-6 col-lg-4">
	                    <div class="m-2">
	                        <span class="h5">Számlázott státusz módosítása</span>
	                        <div class="row">
	                        	<div class="col-12">
	                        		<button
	                        			class="btn btn-primary"
	                        			@click.prevent="cs_change('szamlazva',1)"
	                        		>
	                        			Számlázva	
	                        		</button>
	                        	</div>
	                        </div>
	                    </div>
	                </div>
	                <div class="col-6 col-lg-4">
	                    <div class="m-2">
	                        <span class="h5">Számla kiállító módosítása</span>
	                        <div class="row">
	                        	<div class="col-9">
	                        		<select v-model="cs_szolg" class="form-control">
				  						<option
				  							v-for="(item,index) in szolgShort"
				  							:value="item.id"
				  							:key="`cs-${index}`"
				  						>
				  							{{ item.nev }}
										</option>
									</select>
	                        	</div>
	                        	<div class="col-3">
	                        		<button
		                                class="btn btn-primary"
		                                :disabled="cs_szolg == null"
		                                @click.prevent="cs_szolg_change"
		                            >
		                                Módosít
		                            </button>
	                        	</div>
	                        </div>
	                    </div>
	                </div>

	                <div class="col-6 col-lg-4">
	                    <div class="m-2">
	                        <span class="h5">Kiszállító módosítása</span>
	                        <div class="row">
	                        	<div class="col-9">
	                        		<select v-model="cs_kiszall" class="form-control">
				  						<option
				  							v-for="(item,index) in kiszallitok"
				  							:value="item.azon"
				  							:key="`csk-${index}`"
				  						>
				  							{{ item.nev }}
										</option>
									</select>
	                        	</div>
	                        	<div class="col-3">
	                        		<button
		                                class="btn btn-primary"
		                                :disabled="cs_kiszall == null"
		                                @click.prevent="cs_kiszall_change"
		                            >
		                                Módosít
		                            </button>
	                        	</div>
	                        </div>
	                    </div>
	                </div>

	                <div class="col-12 col-md-6">
	                    <div class="m-2">
	                        <span class="h5">Kiegyenlített státusz módosítása</span>
	                        <div class="row">
	                        	<div class="col-4">
	                        		<span>Kiegyenlítés dátuma</span>
  									<date-picker
  										class="text-center"
  										v-model="cs_fizetve.fizetve_datum"
  										:config="date_options"
  									/>
	                        	</div>
	                        	<div class="col-4">
	                        		<span>Kiegyenlítés helye</span>
	                        		<select v-model="cs_fizetve.fizetve_hely" class="form-control">
				  						<option value="0">Nincs kiegyenlítve</option>
				  						<option
				  							v-for="(v,k) in penztar"
				  							v-if="v.aktiv==1"
				  							:key="k"
				  							:value="v.id"
				  						>
				  							{{ v.nev }}
				  						</option>
									</select>
	                        	</div>
	                        	<div class="col-3">
	                        		<button
		                                class="btn btn-primary"
		                                :disabled="!cs_fizetve.fizetve_datum"
		                                @click.prevent="cs_kiegyenlitve"
		                            >
		                                Módosít
		                            </button>
	                        	</div>
	                        </div>
	                    </div>
	                </div>
	                <div class="col-12 mt-3 pb-3" v-if="true">
	                    <div class="m-2">
	                        <span class="h5">Számlák elkészítése</span>
	                        <div class="alert alert-info h5">
		                		<ul class="text-left">
		                			<li>
		                				Nullás tételeket nem számlázunk ki.
		                			</li>
		                			<li>
		                				Ha egyazon vevő kijelölt rendelésein belül van átutalásos és készpénzes fizetési mód, akkor azt külön számlán kezeli a rendszer.
		                			</li>
		                			<li>
		                				A rendelési felület az adószám megfelelőségét nem ellenőrzi, ezért kérjük ügyeljen az adószám hibátlan megadására vállalkozás esetén, a számlázási hibák elkerülése érdekében.
		                			</li>
		                			<li>
		                				Ha nem töltődik le automatikusan a számla akkor a "Rendelések" menü "Számlázott rendelések" pontban újra letölthető
		                			</li>
		                		</ul>
		                	</div>
	                        <div class="text-center">
                        		<button
                        			class="btn btn-primary"
                        			@click.prevent="cs_szamla()"
                        		>
                        			Számlák generálása
                        		</button>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>

	    <div class="container mt-2 mb-2" v-show="listsum.length > 0">
	    	<div class="h4 text-center">
	    		Összegzés:
	    	</div>
	    	<div
	    		class="row d-flex justify-content-center align-items-center border-bottom"
	    		v-for="(item,index) in listsum"
	    		:key="`sum-${index}`"
	    	>
	    		<div class="col-6">
	    			{{item.termek_nev}}
	    		</div>
	    		<div class="col-2">
	    			{{item.db}} db
	    		</div>
	    		<div class="col-2">
	    			{{item.ar | huf}} Ft
	    		</div>
	    		<div class="col-2">
	    			{{item.ar / item.db | huf}} Ft (Átlag)
	    		</div>
	    	</div>
	    	<div class="row d-flex justify-content-center align-items-center mt-2 h4">
	    		<div class="col-6">
	    			ÖSSZESEN
	    		</div>
	    		<div class="col-2">
	    			- - - -
	    		</div>
	    		<div class="col-2">
	    			{{ listsum_total | huf }} Ft
	    		</div>
	    	</div>
	    	<div class="row d-flex justify-content-center align-items-center mt-1 h4">
	    		<div
	    			class="col-12 col-sm-12 col-md-4 text-center"
	    			v-for="(item,index) in listsum_payment"
	    			:key="`lsp-${index}`"
	    		>
	    			{{ item.text }} - {{ item.sumar | huf }} Ft
	    		</div>
	    	</div>
	    	<div class="row d-flex justify-content-center align-items-center mt-2">
	    		<div class="col-10">
	    			<hr>
	    		</div>
	    	</div>
	    </div>
	    <div class="container mt-2 mb-2" v-show="listsum_szolg.length > 0">
	    	<div class="h4 text-center">
	    		Összegzés szolgáltatónként:
	    	</div>
	    	<div
	    		class="row d-flex justify-content-center align-items-center"
	    		v-for="(item,index) in listsum_szolg"
	    		:key="`sumszolg-${index}`"
	    	>
	    		<div class="col-12">
	    		</div>
	    		<div class="col-6 h5">
	    			{{item.nev !== null ? item.nev : `Nincs szolgáltató`}}
	    		</div>
	    		<div
	    			class="col-2 h5"
	    			v-if="item.nev == 'AQUA'"
	    		>
	    			{{item.arn | huf }} Ft (N)
	    		</div>
	    		<div v-else class="col-2"></div>
	    		<div class="h5 col-2">
	    			{{item.ar | huf }} Ft (Br)
	    		</div>

	    		<div class="col-12">
	    			<div
	    				class="row d-flex justify-content-center align-items-center border-bottom"
	    				v-for="(obj,index) in item.list"
	    				:key="`ls-${index}`"
	    			>
	    				<template v-if="item.nev == 'AQUA'">
	    					<div class="col-4">
		    					{{obj.tetel}}
		    				</div>
		    				<div class="col-2">
		    					{{obj.db}} db
		    				</div>
		    				<div class="col-2">
		    					{{obj.sumn | huf }} Ft (N)
		    				</div>
		    				<div class="col-2">
		    					{{obj.sumbr | huf }} Ft (Br)
		    				</div>
	    				</template>
	    				<template v-else>
	    					<div class="col-6">
		    					{{obj.tetel}}
		    				</div>
		    				<div class="col-2">
		    					{{obj.db}} db
		    				</div>
		    				<div class="col-2">
		    					{{obj.sumbr | huf }} Ft
		    				</div>
	    				</template>
		    				
	    			</div>
	    		</div>
	    		<div class="col-12">
	    			<div
	    				class="row d-flex justify-content-center align-items-center mt-1 h4"
	    			>
			    		<div
			    			class="col-12 col-sm-12 col-md-4 text-center"
			    			v-for="item in listsum_szolg_payment[index].list"
			    		>
			    			{{ item.text }} - {{ item.sumar | huf }} Ft
			    		</div>
			    	</div>
	    		</div>
	    		<div class="col-10">
	    			<hr>
	    		</div>
	    	</div>
	    </div>
	</div>
</template>
<script type="text/javascript">
//import deliveryProtocol from '@/components/print/deliveryProtocol'

export default {
	name: 'order_search',

	components: {
		//deliveryProtocol
	},
	
	data(){
		return {
			list: [],
			listsum: [],
			listsum_payment: [],
			listsum_szolg: [],
			listsum_szolg_payment: [],
			listCount: 0,
			kat: [],
          	tip: [],
          	users: [],
          	zaruser: [],
          	szolg: [],
          	penztar: [],
          	cs_kidatum: null,
          	cs_zardatum: null,
          	cs_szolg: null,
          	cs_kiszall: null,
          	cs_fizetve: {
          		fizetve_datum: this.$moment().format('YYYY-MM-DD'),
          		fizetve_hely: 0
          	},
			search: {
				nev: '',
				uszam: '',
				iszam: '',
				varos: '',
				cim: '',
				regio_kezd: null,
				regio_veg: null,
				aktiv: 1,
				kategoria_id: 0,
				tipus_id: 0,
				lezarta2: 99,
				rogzit: 'Mind',
				ki_datum_tol: null,
				ki_datum_ig: this.$moment().add(1,'days').format('YYYY-MM-DD'),
				r_datum_tol: null,
				r_datum_ig: null,
				t_datum_tol: null,
				t_datum_ig: null,
				szolg: 0,
				szamlazva: 2,
				szla_szolg: [],
				szla_tipus: 0,
				nullas: 0,
				fizetve: 99,
				megj: '',
				kiszallito: -1,
				rendelesszam: ''
			},
			show: {
		  		rogzitette: false,
		  		lezarta: false,
		  		kerdatum: true,
		  		telefon: false,
		  		nev: true,
		  		varos: false,
		  		cim: false,
		  		tetel: true,
		  		db: true,
		  		ar: true,
		  		megj: true,
		  		ertek: true,
		  		fizmod: false,
		  		invnumber: true
		  	},
		  	buttons_past: [
		    	{ text: `Üres`, value: null },
		    	{ text: `Tegnap`, value: 1 },
		    	{ text: `Ma`, value: 0 },
		    	{ text: `Holnap`, value: -1 },
		    ],
		    buttons_now: [
		    	{ text: `Tegnap`, value: -1 },
		    	{ text: `Ma`, value: 0 },
		    	{ text: `Holnap`, value: 1 },
		    	{ text: `Üres`, value: null }
		    ],
		    check: false,
		    order: 'regio',
          	order_dir: false,
          	errors: null,
          	downloadValue: 0,
          	dateButtons: [
          		{
          			text: 'Folyó teljes év',
          			start: this.$moment().startOf('year').format('YYYY-MM-DD'),
          			end: this.$moment().endOf('year').format('YYYY-MM-DD')
          		},
          		{
          			text: 'Múlt év',
          			start: this.$moment().subtract(1,'year').startOf('year').format('YYYY-MM-DD'),
          			end: this.$moment().subtract(1,'year').endOf('year').format('YYYY-MM-DD')
          		},
          		{
          			text: 'Múlt hét',
          			start: this.$moment().subtract(1,'week').startOf('week').format('YYYY-MM-DD'),
          			end: this.$moment().subtract(1,'week').endOf('week').format('YYYY-MM-DD')
          		},
          		{
          			text: 'Futó hét',
          			start: this.$moment().startOf('week').format('YYYY-MM-DD'),
          			end: this.$moment().endOf('week').format('YYYY-MM-DD')
          		},
          		{
          			text: 'Jövő hét',
          			start: this.$moment().add(1,'week').startOf('week').format('YYYY-MM-DD'),
          			end: this.$moment().add(1,'week').endOf('week').format('YYYY-MM-DD')
          		},
          		{
          			text: 'Aktuális hét holnaptól',
          			start: this.$moment().add(1,'day').format('YYYY-MM-DD'),
          			end: this.$moment().endOf('week').format('YYYY-MM-DD')
          		}
          	],
          	kiszallitok: []
		}
	},

	mounted(){
      	this.$Progress.start()
      	this.isLoading = true
      	this.req.post('/others')
          	.then(res => {
              	this.kat = res.data.kat
              	this.kat.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden", "megjegyzes": null })
              	this.tip = res.data.tip
              	this.tip.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden", "megjegyzes": null })
              	this.szolg = res.data.szolg
              	this.szolg.splice(0,0,{ "id": 0, "nev": "Minden", "megjegyzes": null })
              	this.users = res.data.users
              	this.users.splice(0,0,{user: `Mind`, aktiv: 1})
              	this.zaruser = res.data.zaruser
              	this.zaruser.splice(0,0,{lezarta2: 99, nev: `Mind`, aktiv: 1})
              	this.penztar = res.data.penztar
              	this.kiszallitok = res.data.kiszallitok
              	this.$Progress.finish()
              	this.isLoading = false
          	})
          	.catch(err => {
              	this.$Progress.fail()
              	this.isLoading = false
          	})
        if(this.$route.query.customer !== undefined) {
        	this.search.uszam = this.$route.query.customer
        	this.search.aktiv = 0
        	this.search.ki_datum_tol = this.$moment('2015-01-01').format('YYYY-MM-DD')
        	this.search.ki_datum_ig = this.$moment().format('YYYY-MM-DD')
        	this.getsearch()
        }
  	},

	methods: {
		change_item(index, what, value) {
			this.$Progress.start()
			this.req.post('/orders/order/change',{
				index: this.list[index].id,
				prop: what,
				value: value,
				user: this.$store.getters.user.azon
			})
				.then(res => {
					this.$Progress.finish()
					toastr.success(`Mentés sikeres`)
				})
				.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	          	})
		},

		change_szamlazva(index) {
			var value = this.list[index].szamlazva === 0 ? 1 : 0
			this.list[index].szamlazva = value
			this.change_item(index,'szamlazva',value)
		},

		change_lezarva(index) {
			var value = this.list[index].aktiv === '0' ? '1' : '0'
			this.list[index].aktiv = value
			this.change_item(index,'aktiv',value)
		},

		regio_set(from,to) {
			this.search.regio_kezd = from
			this.search.regio_veg = to
		},

		setDate(cell,item) {
			this.search[`${cell}tol`] = item.start
			this.search[`${cell}ig`] = item.end
		},

		date_change(mit,method,value) {
			if(value === null) {
				this.search[mit] = null
			} else {
				this.search[mit] = method === `+` ?
				this.$moment().add(value, 'd').format('YYYY-MM-DD') : this.$moment().subtract(value, 'd').format('YYYY-MM-DD')
			}
		},

		cs_szamla() {
			this.errors = null
			this.isLoading = true
			this.$Progress.start()
			this.req.post('/orders/billing', {
				array: this.checked_items
			}, { responseType: 'blob' } )
				.then(res => {
					const url = window.URL.createObjectURL(new Blob([res.data]))
				   	const link = document.createElement('a')
				   	link.href = url
				   	link.setAttribute('download', 'számlák.pdf')
				   	document.body.appendChild(link)
				   	link.click()
					this.$Progress.finish()
					this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					toastr.error(err.response.data.text || 'hiba a számlázásban')
					this.errors = err.response.data.errors
			      	this.$Progress.fail()
			      	this.isLoading = false
				})
		},

		cs_kiegyenlitve() {
			this.$Progress.start()
			this.req.post('/orders/changeFizetve',{
				array: this.checked_items,
				options: this.cs_fizetve
			})
			.then(res=>{
				toastr.success('Változtatás sikeres')
				this.cs_fizetve = {
          			fizetve_datum: this.$moment().format('YYYY-MM-DD'),
          			fizetve_hely: 0
          		}
				this.check_list()
				this.getsearch()
				this.$Progress.finish()
			})
			.catch(err=>{
				console.error(err)
				toastr.error(err.response.data.text||err)
			    this.$Progress.fail()
			})
		},

		cs_change(mit,value) {
			this.$Progress.start()
			this.req.post('/orders/change',{
				array: this.checked_items,
				change: mit,
				value: value == 1 ? 1 : this.$moment(value).format('YYYY-MM-DD'),
				user: this.$store.getters.user.azon
			})
			.then(res=>{
				toastr.success('Változtatás sikeres')
				this.cs_kidatum = null
				this.cs_zardatum = null
				this.check = false
				this.check_list()
				this.getsearch()
				this.$Progress.finish()
			})
			.catch(err=>{
				console.error(err)
				toastr.error(err.response.data.text||err)
				this.$Progress.fail()
			})
		},

		cs_szolg_change() {
			this.$Progress.start()
			this.req.post('/orders/changeSzolg', {
				array: this.checked_items,
				szolg: this.cs_szolg,
			})
			.then(res=>{
				toastr.success('Változtatás sikeres')
				this.check = false
				this.cs_szolg = null
				this.check_list()
				this.getsearch()
				this.$Progress.finish()
			})
			.catch(err => {
				console.error(err)
				toastr.error(err.response.data.text || 'Változtatás sikertelen')
				this.$Progress.fail()
			})
		},

		cs_kiszall_change() {
			this.$Progress.start()
			this.req.post('/orders/changeKiszall', {
				array: this.checked_items,
				kiszallito: this.cs_kiszall,
			})
			.then(res=>{
				toastr.success('Változtatás sikeres')
				this.check = false
				this.cs_kiszall = null
				this.check_list()
				this.getsearch()
				this.$Progress.finish()
			})
			.catch(err => {
				console.error(err)
				toastr.error('Változtatás sikertelen')
				this.$Progress.fail()
			})
		},

		check_list(){
          	for (var i in this.list) {
              	this.list[i].check = this.check
          	}
      	},

		clear(item){
			this.search[item] = ``
		},

		defaultsearch(){
			this.search = {
				nev: '',
				uszam: '',
				iszam: '',
				varos: '',
				cim: '',
				regio_kezd: null,
				regio_veg: null,
				aktiv: 1,
				kategoria_id: 0,
				tipus_id: 0,
				lezarta2: 99,
				rogzit: 'Mind',
				ki_datum_tol: null,
				ki_datum_ig: this.$moment().add(1,'days').format('YYYY-MM-DD'),
				r_datum_tol: null,
				r_datum_ig: null,
				t_datum_tol: null,
				t_datum_ig: null,
				szolg: [],
				szamlazva: 2,
				szla_szolg: 0,
				szla_tipus: 0,
				nullas: 0,
				fizetve: 99,
				megj: '',
				kiszallito: -1,
				rendelesszam: ''
			},
			this.list = []
			this.listsum = []
			this.listsum_szolg = []
			this.listsum_payment = []
			this.listsum_szolg_payment = []
			this.listCount = 0
		},

		getsearch(){
			// Kötelező: kért szállítási dátum -ig. Üres -tól esetén a -ig előtti 1 év
			// (az API ugyanezt ellenőrzi, max. 1 év, ügyfélre szűrve korlátlan).
			if(!this.search.ki_datum_ig) {
				toastr.error('A kért szállítási dátum -ig mező kitöltése kötelező')
				return
			}
			if(!this.search.ki_datum_tol) {
				this.search.ki_datum_tol = this.$moment(this.search.ki_datum_ig).subtract(1, 'year').format('YYYY-MM-DD')
			}
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/orders/search', {
				search: this.search,
              	order: this.order,
              	order_dir: this.order_dir
			})
				.then(res => {
					this.list = res.data.list
					this.listCount = res.data.listCount
					this.getsearchsum()
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					if(err.response && err.response.data && err.response.data.text) toastr.error(err.response.data.text)
					this.$Progress.fail()
					this.isLoading = false
				})
		},

		getsearchsum() {
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/orders/searchsum', {
				search: this.search,
				arr: this.checked_items,
				type: this.downloadValue
			})
				.then(res => {
					this.listsum = res.data.list
					this.listsum_szolg = res.data.list_szolg
					this.listsum_payment = res.data.list_tipus
					this.listsum_szolg_payment = res.data.list_szolg_tipus
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
					this.isLoading = false
				})
		},

		async print() {
			this.$Progress.start()
			this.isLoading = true
			var printlist = await this.req.post('/orders/searchWithList', {
				search: this.search,
				arr: this.checked_items,
				type: this.downloadValue
			})
			this.req.post('/orders/print_order_list',{
				list: printlist.data.list,
				listsum: printlist.data.listsum,
				listsum_payment: printlist.data.list_tipus,
				listsum_szolg: printlist.data.list_szolg,
				listsum_szolg_payment: printlist.data.list_szolg_tipus,
			},{ responseType: 'blob'} )
				.then(res => {
					const url = window.URL.createObjectURL(new Blob([res.data]))
				   	const link = document.createElement('a')
				   	link.href = url
				   	link.setAttribute('download', `${this.$moment().format('YYYY-MM-DD').toString()}-${this.search.regio_kezd||'0'}-${this.search.regio_veg||'9999'}.pdf`)
				   	document.body.appendChild(link)
				   	link.click()
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
					this.isLoading = false
				})
		},

		async print2() {
			this.$Progress.start()
			this.isLoading = true
			var printlist = await this.req.post('/orders/searchWithList', {
				search: this.search,
				arr: this.checked_items,
				type: this.downloadValue
			})
			this.req.post('/orders/print_order_list2',{
				search: this.search,
				list: printlist.data.list
			},{ responseType: 'blob'} )
				.then(res => {
					const url = window.URL.createObjectURL(new Blob([res.data]))
				   	const link = document.createElement('a')
				   	link.href = url
				   	link.setAttribute('download', `${this.$moment().format('YYYY-MM-DD').toString()}-${this.search.regio_kezd||'0'}-${this.search.regio_veg||'9999'}-jegyzokony.pdf`)
				   	document.body.appendChild(link)
				   	link.click()
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
					this.isLoading = false
				})
		}
	},

	computed: {
		checked_items(){
			if(this.list == null) return []
          	return this.list.filter(x=>x.check).map(el=>el.id)
      	},

      	checked_items_sum() {
      		if(this.list == null) return 0
      		return this.list.filter(x=>x.check).reduce((t,c) => t + (c.ar*c.db), 0)
      	},

      	listsum_total(){
      		return this.listsum.reduce((total, current) => total + ~~current.ar, 0)
      	},

      	szolgShort() {
      		return this.szolg.filter(x => x.id != 0 && x.aktiv != 0)
      	},

      	szla_szolg() {
      		let arr = []
      		this.szolg.map(sz=>{
      			arr.push({
      				code: sz.id,
      				label: sz.nev
      			})
      		})
      		return arr
      	}
	},

	watch: {
      	order(){
          	this.getsearch()
      	},
      	order_dir(){
          	this.getsearch()
      	}
  	}
}
</script>
<style type="text/css" scoped>
.table-wrapper {
	max-height: 1600px;
	overflow-y: auto;
}

.table-header {
	z-index: 1;
}

thead th {
  	position: sticky;
  	top: 0;
}

.clear {
	cursor: pointer;
}

i {
  	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/orders/order_list/order_search.vue